"use client"
import { useLanguage } from "@/app/utils/LanguageContext";
import { text_size } from "@/app/utils/MixinSize";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
`;
const ContainerItem = styled.div`
    width: 50%;
    background-color: rgb(237, 237, 237);
    padding: 5px;
    text-align: center;
    border-radius: 0px 0px 4px 4px;
`;
const ContainerTitle = styled.div`
  width: 100%;
  padding-top: 5px;
  padding-left: 12px;
`;
const ContainerItemLink = styled.a`
  color: #244FA1;
  -webkit-text-size-adjust: none;
  cursor: pointer;
  ${text_size(13)}
  line-height: 140%;
  padding:8px 8px 8px 12px;
  &:hover{
    text-decoration: underline;
  }
`;

interface propType {
  seasonList: string[];
}

const SeasonHighlights = (props: propType) => {
  const { state: lang } = useLanguage();
  const { t } = lang;
  const { seasonList } = props;

  // const cutOffSeason = window.globalConfig?.OTHERS?.CUTOFF_SEASON;

  const genRedirectLink = (season: string = "") => {
    const years = season?.split("_")
    if (years?.length != 2) return <></>
    // if (season == cutOffSeason) {
    //   // old world site
    //   return <ContainerItemLink id="fixture_past_season_highlights_1" href={`https://racing.hkjc.com/racing/${lang.langType}/racing-info/simulcast_fixture.aspx?y=${season.replace("_", "")}`} target="_blank">20{years[0]} - 20{years[1]}</ContainerItemLink>
    // } else {
      return <ContainerItemLink id="fixture_past_season_highlights_2" href={`/${lang.langCode}/overseas/simulcast_fixture?y=${season.replace("_", "")}`} target="_self">20{years[0]} - 20{years[1]}</ContainerItemLink>
    // }
  }

  return (
    <>
      <ContainerTitle>
        <strong>{t("PastSeasonHighlights")}</strong>
      </ContainerTitle>
      <Container>
        <ContainerItem>
          {genRedirectLink(seasonList[0])}
        </ContainerItem>
        <ContainerItem>
          {genRedirectLink(seasonList[1])}
        </ContainerItem>
      </Container>
    </>
  )
}

export {
  SeasonHighlights
};

